<template>
  <div class="slo-table-container border rounded">
    <ProductCatalogueTable
      :loading="loading"
      :items="penalties"
      type="service_level_objectives"
      :cols-map="colsMap"
      class="m-0 shadow-none"
      @delete="openDeleteDialog"
      @update="(id: any) => $emit('update', id)"
    />
  </div>
  <DeleteDialog
    :open="isDeleteDialogOpen"
    @delete="deletePenalty"
    @close="isDeleteDialogOpen = false"
  />
</template>
<script lang="ts" setup>
defineProps<{
  penalties: ServiceLevelObjectivePenalty[];
  loading?: boolean;
}>();

const emit = defineEmits<{
  update: [value: number];
  delete: [value: number];
}>();

const serviceLevelObjectivesStore = useServiceLevelObjectivesStore();

const colsMap = readonly<{[key: string]: string}>({
  'Penalty Name': 'name',
  Percentage: 'percentage',
  'Service Credit': 'service_credit',
});

const isDeleteDialogOpen = ref(false);
const idToDelete = ref(0);
const openDeleteDialog = (id: number) => {
  isDeleteDialogOpen.value = true;
  idToDelete.value = id;
};

const deletePenalty = async () => {
  try {
    await serviceLevelObjectivesStore.deletePenalty(idToDelete.value);
    emit('delete', idToDelete.value);
  } catch (errorMessage) {
    console.log(errorMessage);
  } finally {
    isDeleteDialogOpen.value = false;
  }
};
</script>
<style lang="scss" scoped>
.slo-table-container {
  border-color: var(--bs-input-border-color);
}
</style>
